module.exports = __webpack_public_path__ + "static/media/09_tn.9ad22ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/09_tn.jpg
// module id = 645
// module chunks = 0